import { Property } from '@bbraun/bav-reporting/ui-report-editor';
import { marker as i18n } from '@ngneat/transloco-keys-manager/marker';
import { IS_GREATER_OR_EQUAL_NUMBER_ID } from '../../../../validation/factories/is-greater-or-equal-number-validator-factory';
import { IS_LOWER_OR_EQUAL_TO_NUMBER_ID } from '../../../../validation/factories/is-lower-or-equal-to-number-validator-factory';
import { IS_NUMBER_ID } from '../../../../validation/factories/is-number-validator-factory';

export function createTransferrinSaturationMeanProperty(): Property {
  return {
    title: 'TSAT - Mean',
    technicalName: 'transferrinSaturationMean',
    dataType: 'number',
    unit: '%',
    highlighted: false,
    subName: null,
    formula: null,
    validation: [
      { validator: IS_NUMBER_ID },
      {
        validator: IS_GREATER_OR_EQUAL_NUMBER_ID,
        options: {
          config: {
            minimum: 0,
          },
        },
      },
      {
        validator: IS_LOWER_OR_EQUAL_TO_NUMBER_ID,
        options: {
          config: { maximum: 100 },
          messageKey: i18n(
            'bbraunBavReportingFeatureAisReports.validation.transferrinSaturationMean.notLowerOrEqual.100.error.message',
          ),
        },
      },
    ],
  };
}
